<template>
  <div class="consult">
    <ListTitle :title="title" :titleImg="titleImg" />
    <ListGroup :itemList="itemList" :fn="goToDetails" />
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/layouts/footer.vue";
import ListTitle from "@/components/ui/searchList/ListTitle.vue";
import ListGroup from "@/components/ui/searchList/ListGroup.vue";
export default {
  props: {
    title: {
      type: String,
      default: "專家諮詢"
    },
    titleImg: {
      type: String,
      default: "common/icon_consult.svg"
    }
  },
  data() {
    return {
      itemList: []
    };
  },
  components: {
    Footer,
    ListTitle,
    ListGroup
  },
  computed: {
    cTitleImg() {
      let path = this.titleImg;
      return require(`@/assets/images/${path}`);
    }
  },
  methods: {
    goToDetails(item) {
      this.SYS.goToDetails(
        item,
        item.sno,
        this.itemList,
        "Consult-Detail"
        //this.$router
      );
    },
    getConsultDetail() {
      this.$store.dispatch("setLoading", true);
      return this.axios({
        methods: "get",
        url: `${process.env.VUE_APP_API_URL}api/Consult/GetConsultList`
      }).then(resp => {
        // this.item = resp.data.data;
        let model = {
          category: 1,
          title: "標題",
          onlineDate: Date.now(),
          content: "內容",
          sno: 0
        };
        this.itemList = [];
        for (let i = 0; i < resp.data.data.length; i++) {
          let item = resp.data.data[i];
          model.category = item.category;
          model.subcategory = item.subcategory;
          model.title = item.Title;
          model.onlineDate = item.PublicTime;
          model.content = item.Content;
          model.sno = item.Sno;
          model.img = item.img;
          model.answerStr = this.setAnswerStr(item.AnswerList);
          this.itemList.push(JSON.parse(JSON.stringify(model)));
        }
        this.$store.dispatch("setLoading", false);
        // if (
        //   typeof this.item.photoList !== "undefined" &&
        //   this.item.photoList.length > 0
        // ) {
        //   this.photoList = this.item.photoList;
        //   this.photoItem = this.item.photoList[0];
        // }
      });
    },
    setAnswerStr(arr) {
      let str = "";
      for (let i = 0; i < arr.length; i++) {
        if (i < arr.length - 1) {
          str += arr[i].UserId + "、";
        } else {
          str += arr[i].UserId;
        }
      }
      return str;
    }
  },
  mounted() {
    this.getConsultDetail();
  }
};
</script>
<style lang="scss" scoped>
.consult {
  background-color: #f6edd9;
  .titleContent {
    background-repeat: repeat;
    background-position: 50% 50%;
    background-image: url("~@/assets/images/announce/bg_title.png");
  }
}
</style>
